export const storeES_MX = {
	backofficeStore: {
		createTransfer: "Transferencia realizada con éxito",
		editTransfer: "Transferencia editada con éxito",
		deleteTransfer: "Transferencia eliminada con éxito",
		editBill: "Cuenta editada con éxito",
		deleteBill: "Cuenta eliminada",
		importBackofficeBills: "Cuentas importadas",
		createBillTypes: "Tipo de cuenta creada con éxito",
		createCostCenters: "Centro de costo creado",
		deleteCostCenter: "Centro de costo eliminado",
		editCostCenter: "Centro de costo editado",
		deleteAccount: "Cuenta de cliente eliminada",
		editAccount: "Cuenta de cliente editada",
		editBillTypes: "Tipo de cuenta editada",
		deleteBillTypes: "Tipo de cuenta eliminada",
		createCategorie: "Categoría creada",
		editCategorie: "Categoría editada",
		deleteCategorie: "Categoría eliminada",
		addStorage: "Inventario creado con éxito",
		updateStorage: "Inventario modificado con éxito",
		updateBar: "Bar editado con éxito",
		deleteBar: "El bar fue eliminado",
		addBar: "Bar agregado",
		createNewSupplier: "Nuevo proveedor agregado con éxito",
		inputBackofficeProductsV2_zero: "Productos agregados al inventario",
		inputBackofficeProductsV2_other: "Uno o más productos no fueron agregados",
		zeroBackofficeAllProductsAtStorage: "Todos los productos agotados",
		editSupplier: "Proveedor editado con éxito",
		saveBackofficeProductsQuantityV2: "Producto actualizado",
		deleteBackofficeProduct: "Producto eliminado del inventario",
		deleteBackofficeProducts: "Todos los productos fueron eliminados del inventario",
		deleteSupplier: "Proveedor eliminado con éxito",
		transferBackofficeProduct: "Producto transferido",
		createAccount: "Cuenta registrada con éxito",
		deleteInvoices: "Facturas fiscales eliminadas con éxito",
	},
	barStore: {
		deleteBar: "Bar eliminado.",
		editBar: "Bar actualizado.",
		addTableBarRange: "Configuración de impresión por mesa agregada.",
		editTableBarRange: "Configuración de impresión por mesa actualizada.",
		deleteRange: "Configuración de impresión por mesa eliminada.",
	},
	cmvStore: {
		error: {
			getCategories: "Error al buscar categoría",
		},
		updatedProductsWithoutCostOnSells: "Costo actualizado con éxito",
	},
	cashierStore: {
		bleedCashier_zero: "Fondo de cambio realizado con éxito",
		bleedCashier_other: "Retiro realizado con éxito.",
		addCashierClosingObs: "Observación agregada.",
		createCashierChangeLEGACY: "Fondo de cambio agregado",
		createMultipleChangesLEGACY: "Todos los fondos fueron registrados",
		createMultipleChangesLEGACYError:
			"{{errors}} de {{cashiersId}} dieron error: {{jsonErrors}}",
		createBleedLEGACY: "Retiro agregado",
		updateCashierClosingLEGACY: "Caja cerrada con éxito",
	},
	clientStore: {
		getClientByCPFOrPhone: "Cliente agregado",
		editClientDetails: "Detalles de cliente actualizados.",
		editClientDetailsPlace: "Detalles de cliente actualizados.",
		editUserDetails: "Detalles de cliente actualizados.",
		payBillAtPlace: "Cuenta pagada con éxito",
		payAllBillsAtPlace: "Cuentas pagadas con éxito",
		clientAlreadyAdded: "Este cliente ya fue agregado",
		payBillsSuccess: "Cuentas pagadas con éxito",
		payBillsWarning:
			"{{success}} cuentas pagadas con éxito, y {{errors}} errores al pagar cuentas.",
		payBillsLoading: "Marcando como pagado",
		createPixCharge: "PIX generado con éxito",
		updatedProductsWithoutCostOnSells: "Costo actualizado con éxito",
		refundAppSell:
			"¡Transacción reembolsada con éxito! Actualice la página para visualizar la información correctamente.",
		cancelAppSell:
			"¡Transacción cancelada con éxito! Actualice la página para visualizar la información correctamente.",
	},
	comboStore: {
		createCombo: "Combo creado.",
		deleteCombo: "Combo eliminado.",
		editCombo: "Combo actualizado.",
	},
	deliveryStore: {
		deleteMenu: "¡Menú eliminado con éxito!",
		addProduct: "¡Producto agregado con éxito!",
		addProductV2: "¡Producto agregado con éxito!",
		activateManyProductsLoading: "Activando productos",
		activateManyProductsWarning:
			"{{countFailures}} producto(s) no pudieron ser actualizados.",
		deactivateManyProductsLoading: "Desactivando productos",
		deactivateManyProductsWarning:
			"{{countFailures}} producto(s) no pudieron ser actualizados.",
	},
	deviceStore: {
		removeDeviceFromEvent: "Dispositivo retirado del evento.",
		updateEmployeeDeviceConfigs: "PDV configurado con éxito",
		addDevice: "Dispositivo agregado al Local con éxito",
	},
	employeeStore: {
		addEmployee: "Empleado agregado.",
		editEmployee: "Empleado actualizado.",
		removeEmployee: "Empleado eliminado.",
		addMultipleEmployees: {
			error: "Colaboradores no agregados:",
			success: "Colaboradores agregados con éxito:",
		},
		editMultipleEmployees: "Colaboradores modificados con éxito",
		removeMultipleEmployees: "{{successCount}} colaboradores eliminados con éxito",
		removeMultipleEmployeesError:
			"{{errorCount}} colaboradores no pudieron ser eliminados",
		createRole: "Cargo creado con éxito",
		deleteRole: "Cargo eliminado con éxito",
		updateRole: "Cargo editado con éxito",
	},
	eventStore: {
		createEvent: "Evento creado.",
		openEvent: "Evento abierto.",
		payBillAtEventWithMultiplePayments: "Cuenta pagada con éxito",
		payAllBillsAtEvent: "Cuentas pagadas con éxito",
		closeEvent: "Evento cerrado.",
		eventEditedSuccessfully: "Evento editado con éxito",
		closeEventLoading: "Cerrando evento",
		deleteEvent: "Evento eliminado.",
		emitInnovaroGeneralInvoices: "Facturas emitidas con éxito",
		refundFichaSell: "Ficha reembolsada con éxito",
		giveRechargeToUser: "Recarga efectuada con éxito",
	},
	extractStore: {
		createBankAccount: "Cuenta bancaria creada con éxito.",
		deleteBankAccount: "¡Cuenta bancaria eliminada con éxito!",
		updateBankAccount: "¡Cuenta bancaria actualizada con éxito!",
		createAdjustmentInVendorExtract: "Ajuste agregado con éxito",
		payVendorWithdrawRequests: "¡Aprobaciones enviadas con éxito!",
		revertManyVendorsWithDrawRequests: "¡Rechazo de solicitud enviado con éxito!",
		orderWithdrawCancellation: "Solicitud de cancelación realizada con éxito.",
	},
	fiscalStore: {
		createFiscalProfile: "Éxito al crear perfil fiscal.",
		editFiscalProfile: "Éxito al actualizar perfil fiscal.",
		createFiscalProductGroup: "Éxito al crear grupo fiscal.",
		editFiscalProductGroup: "Éxito al actualizar grupo fiscal.",
		deleteFiscalProductGroup: "Éxito al actualizar grupo fiscal.",
		issueManualInvoiceForReserveError_zero:
			"Error al generar {{failedInvoiceCount}} facturas fiscales",
		issueManualInvoiceForReserveError: "Error n°{{number}}: {{error}}",
		issueManualInvoiceForReserve_zero: "Todas las Facturas fiscales generadas con éxito",
		issueManualInvoiceForReserve_other:
			"{{issuedInvoices}} Facturas fiscales generadas con éxito",
		minimumConsumptionFiscalSuccess: "Consumo mínimo configurado con éxito",
		rechargeFiscalSuccess: "Recarga configurada con éxito",
	},
	invoiceStore: {
		notifyOfIssuing_zero: "No había facturas para emitir",
		notifyOfIssuing_other: "{{invoiceCount}} facturas fiscales emitidas",
		notifyOfIssuingWarning_other:
			"{{issuedInvoices}} facturas fiscales emitidas, pero se encontraron los siguientes errores: {{errors}}",
		notifyOfIssuingWarning_zero:
			"Ninguna factura fiscal emitida, se encontraron los siguientes errores: {{errors}}",
		issueAllEventInvoices: "Facturas fiscales de evento emitidas.",
		sendInvoicesByEmail: "Facturas enviadas por email.",
		cancelInvoice: "¡Factura fiscal cancelada con éxito!",
		cancelInvoiceNC:
			"¡Nota de crédito generada con éxito! Su nota de crédito estará disponible en breve.",
		issueInvoicesOfTransactions: "Facturas fiscales emitidas",
	},
	itemStore: {
		activateProductsInPlaceLoading: "Activando productos",
		activateProductsInPlace: "Productos activados",
		deactivateProductsInPlaceLoading: "Desactivando productos",
		deactivateProductsInPlace: "Productos desactivados",
		createCategory: "Categoría creada con éxito",
		editCategory: "Categoría actualizada",
		deleteCategory: "Categoría eliminada",
		addProduct: "Producto agregado",
		importProductsError: "Error en la edición del producto {{name}}: {{message}}",
		importProducts: "{{products}} Productos importados",
		importProductsWarning:
			"{{products}} Productos importados y {{errorCounter}} productos tuvieron problemas en la importación",
		editProduct: "Producto actualizado",
		importProductsToEditError: "Error en la edición del producto {{name}}: {{message}}",
		importProductsToEdit: "{{products}} Productos editados",
		importProductsToEditWarning:
			"{{products}} Productos editados y {{errorCounter}} productos tuvieron problemas en la edición",
		deleteProduct: "Producto eliminado",
		deleteProductError: "Error al eliminar producto",
		deleteProductFromPlace: "Producto eliminado",
		activateMountableSectionItem_all: "Elementos activados con éxito",
		activateMountableSectionItem_one: "Elemento activado con éxito",
		deactivateMountableSectionItem_all: "Elementos desactivados con éxito",
		deactivateMountableSectionItem_one: "Elemento desactivado con éxito",
		addSupply: "Insumo agregado",
		editSupply: "Insumo modificado",
		createEntrance: "Entrada agregada",
		deleteEntrance: "Entrada eliminada",
		editEntrance: "Entrada actualizada",
		editEntranceImage: "Entrada actualizada",
		attachProductionRule: "Ficha técnica creada con éxito",
		removeProductionRule: "Ficha técnica eliminada con éxito",
		editProductionRule: "Regla de producción actualizada",
		removedProductionRuleInput: "Insumo eliminado con éxito",
		editMultipleProducts: "¡{{name}} modificado con éxito!",
		editMultipleProductsError: "{{name}} no pudo ser alterado: {{reason}}",
		deleteMultipleProducts: "Eliminados con éxito",
		createBeerTap: "¡Grifo de cerveza creado con éxito!",
		editBeerTap: "¡Grifo de cerveza editado con éxito!",
		removeBeerTap: "¡Grifo de cerveza eliminado con éxito!",
		activatingProduct: "Activando producto",
		deactivatingProduct: "Desactivando producto",
		activatedProduct: "Producto activado",
		deactivatedProduct: "Producto desactivado",
		activatingEntrance: "Activando entrada",
		deactivatingEntrance: "Desactivando entrada",
		activatedEntrance: "Entrada activada",
		deactivatedEntrance: "Entrada desactivada",
		errorToAdd: "Error al agregar {{name}}",
	},
	organizationStore: {
		addGiftback: "Giftback creado con éxito",
		addProductToOrg: "Producto agregado",
		addMultipleOrgProducts: "Productos Agregados",
		editGiftback: "Giftback modificado con éxito",
		editOrgProduct: "Producto editado",
		editMultipleOrgProducts: "Productos editados",
		deleteMultipleOrgProducts:
			"({{products}}) productos fueron eliminados del inventario de todos los locales.",
		deleteGiftback: "Giftback eliminado con éxito",
		deleteProduct: "Producto eliminado",
		deleteProductError: "Error al eliminar producto",
		tooglePlaces: "Locales modificados",
		addMultipleProductsInPlace: "Locales modificados",
		activateGiftback: "Giftback activado con éxito",
		deactivateGiftback: "Giftback desactivado con éxito",
	},
	placeStore: {
		editEverestConfigWarning: "Validando datos con la everest",
		editEverestConfig: "Datos de everest actualizados.",
		editPlace: "Local actualizado.",
		confirmSignPlaceContracts: "La firma fue concluida con éxito.",
		createStorageAlerts: "Alerta creada con éxito",
		editStorageAlerts: "Alerta editada con éxito",
		deleteStorageAlerts: "Alerta eliminada con éxito",
		addEmailToMinimumStorageAlert: "Emails registrados con éxito",
		removeEmailToMinimumStorageAlert: "Email eliminado con éxito",
		deleteDiscountCategory: "¡Descuento eliminado con éxito!",
		activateDiscountCategory: "¡Descuento activado con éxito!",
		disableDiscountCategory: "¡Descuento desactivado con éxito!",
		createManualLostReport: "Pérdida manual creada con éxito.",
		updatePlaceSettingsGeneralSection: "Configuraciones generales actualizadas.",
		updatePlaceSettingsFichaSection: "Configuraciones de ficha actualizadas.",
		updatePlaceSettingsCouvertSection: "Configuraciones de Cover actualizadas.",
		updatePlaceSettingsPlaceFeatureSection:
			"Configuraciones de las funcionalidades actualizadas.",
		updatePlaceSettingsPDVSection: "Configuraciones de PDV actualizadas.",
		updatePlaceSettingsTotemSection: "Configuraciones de Tótem actualizadas.",
		createPixCharge: "PIX generado con éxito",
	},
	productFeatureStore: {
		org: "ORG",
		zig: "ZIG",
		createProductFeatureTemplate:
			"¡Modelo de funcionalidad de producto creada con éxito!",
		editProductFeatureTemplate: "¡Modelo de funcionalidad de producto editado con éxito!",
		removeProductFeatureTemplate:
			"¡Modelo de funcionalidad de producto eliminado con éxito!",
		createProductFeature: "¡Funcionalidad del producto creada con éxito!",
		editProductFeature: "¡Funcionalidad del producto editada con éxito!",
		removeProductFeature: "¡Funcionalidad del producto eliminada con éxito!",
		removeProductFeaturesByTemplateId:
			"¡Funcionalidades de producto ligadas al modelo fueron eliminadas con éxito!",
	},
	promotionStore: {
		createPromotion: "Promoción creada con éxito",
		editPromotion: "Promoción editada con éxito",
		updatePromotionPeople: "Clientes actualizados con éxito",
		usersInfoRewriteLoading:
			"Buscando datos de los clientes, esto puede demorar bastante",
	},
	relationStore: {
		editRelation: "¡Información de la lista editada con éxito!",
		deleteRelation: "Lista eliminada con éxito",
		deleteMultipleRelation_one: "Lista eliminada con éxito",
		deleteMultipleRelation_other: "Listas eliminadas con éxito",
		addRelationUser: "¡Invitado agregado con éxito!",
		editRelationUser: "¡Invitado editado con éxito!",
		deleteRelationUser: "Usuario eliminado de la lista con éxito",
		activateOrDeactivateRelation_active: "Lista activada con éxito",
		activateOrDeactivateRelation_deactive: "Lista desactivada con éxito",
	},
	reserveStore: {
		addReserve: "Paquete creado con éxito",
		editReserve: "Paquete modificado con éxito",
		deleteReserve: "Paquete eliminado con éxito",
		createReserveTemplate: "¡Modelo de paquete creado con éxito!",
	},
	smsStore: {
		cancelSmsCampaign: "Cancelación de la programación fue realizada.",
		editSmsCampaignClients: "Grupo de destinatarios modificado.",
	},
	vendorStore: {
		createVendor: "Vendor creado con éxito",
		editVendor: "Vendor editado con éxito",
	},
	whatsUpStore: {
		setPlaceDetailStatus_active: "Local activo en Zig App",
		setPlaceDetailStatus_inactive: "Local inactivo en Zig App",
	},
};
